export enum EToastContainerIds {
  stacked = 'stacked',
}
